import { render, staticRenderFns } from "./zenga-used-property.vue?vue&type=template&id=07733f60&scoped=true&lang=pug"
import script from "./zenga-used-property.vue?vue&type=script&setup=true&lang=js"
export * from "./zenga-used-property.vue?vue&type=script&setup=true&lang=js"
import style0 from "./zenga-used-property.vue?vue&type=style&index=0&id=07733f60&prod&lang=scss&scoped=true"
import style1 from "./zenga-used-property.vue?vue&type=style&index=1&id=07733f60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07733f60",
  null
  
)

export default component.exports